import React from 'react';
import { ICON } from '../../icons/iconIds';
import SelkirkIcon from '../icons/SelkirkIcon';
import { LAYOUT_SLOTS, slotFitness } from './slotFitness';

const COVER_SLOT = LAYOUT_SLOTS.find((s) => s.id === 'cover');

const MediaCard = ({ item, selected, onSelect }) => {
  const src = item.is_vector
    ? (item.original_url || item.renditions?.thumb?.url || item.renditions?.web?.url)
    : (item.renditions?.thumb?.url || item.renditions?.web?.url || item.original_url);
  const cover = slotFitness(item, COVER_SLOT);
  const flagged = item.ppe_concern || item.people_consent === 'None';

  return (
    <button
      type="button"
      className={`dd-media-card ${selected ? 'selected' : ''}`}
      onClick={() => onSelect(item)}
      title={item.description || item.file_name}
    >
      <div className="dd-media-thumb">
        {src ? <img src={src} alt={item.description || item.file_name} loading="lazy" /> : <span>No preview</span>}
        <div className="dd-media-badges">
          {item.approved_external && <span className="dd-badge approved" title="Approved for external use"><SelkirkIcon name={ICON.uiCheckOn} size={12} decorative /> External</span>}
          {flagged && <span className="dd-badge flagged" title={item.ppe_notes || 'Safety or consent concern'}><SelkirkIcon name={ICON.uiWarning} size={12} decorative /></span>}
          {cover.rating === 'good' && item.orientation === 'portrait' && (
            <span className="dd-badge cover" title="Resolution suits a full-bleed cover">Cover</span>
          )}
          {item.is_vector && <span className="dd-badge muted" title="Vector graphic">SVG</span>}
          {item.enrichment_status === 'pending' && <span className="dd-badge muted" title="AI tagging queued">AI…</span>}
        </div>
      </div>
      <div className="dd-media-meta">
        <span className="dd-media-name">{item.file_name}</span>
        <span className="dd-media-sub">
          {item.width_px && item.height_px ? `${item.width_px}×${item.height_px}` : item.is_vector ? 'Vector' : '—'}
          {item.folder_path ? ` · ${item.folder_path}` : ''}
        </span>
      </div>
    </button>
  );
};

const MediaGrid = ({ items, selectedId, onSelect }) => (
  <div className="dd-media-grid">
    {items.map((item) => (
      <MediaCard key={item.id} item={item} selected={item.id === selectedId} onSelect={onSelect} />
    ))}
  </div>
);

export default MediaGrid;
